import { LoaderContainer } from "./styles";

const Loader = ({ margin, className }) => {
    return (
        <LoaderContainer className={`loader ${className || ""}`} margin={margin}> 
            <div className="spinner">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
            </div>
        </LoaderContainer>
    )
}

export default Loader;